<app-section-loader [loading]="loading"></app-section-loader>
<div class="mContent__header bg-primary py-3 px-5">
  <h1 class="text-white mb-1">Reports - Districts</h1>
  <form [formGroup]="reportForm">
    <div class="mControls">
      <div class="input-group">
        <mat-form-field appearance="outline" class="input-white no-error">
          <mat-label>School District</mat-label>
          <mat-select formControlName="district" (selectionChange)="districtSelected($event)">
            <mat-option *ngFor="let district of allDistricts" [value]="district.id">
              {{district.district_name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="input-group">
        <mat-form-field appearance="outline" class="input-white no-error">
          <mat-label>School Year</mat-label>
          <mat-select formControlName="school_year" (selectionChange)="reportLoaded = false;">
            <mat-option *ngFor="let year of schoolYears" [value]="year">
              {{year}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="input-group mr-auto">
        <button (click)="renderReport(reportForm.value)" mat-raised-button [disabled]="!reportForm.valid">
          <mat-icon>play_arrow</mat-icon> Run Report
        </button>
      </div>
      <div class="mControls__right">
        <div class="input-group">
          <button mat-raised-button [disabled]="!reportLoaded" (click)="exportAllReports()">
            <mat-icon>publish</mat-icon> Export Report
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<div class="scroll flex-fill overflow-auto py-3 px-5" *ngIf="filtersSelected && reportLoaded">
  <div class="container p-0 h-100">
    <div class="d-flex flex-column h-100 tab-group-area">
      <mat-tab-group (selectedIndexChange)="setListForTab($event)">
        <mat-tab label="1st Grade">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
        <mat-tab label="2nd Grade">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
        <mat-tab label="3rd Grade">
          <ng-container *ngTemplateOutlet="tabContent"></ng-container>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>

<div class="flex-fill d-flex" *ngIf="!filtersSelected">
  <div class="m-auto">
    <img src="assets/images/no-result.png" alt="">
    <h2 class="text-center">Select filters and run a report</h2>
  </div>
</div>
<div class="flex-fill d-flex" *ngIf="filtersSelected && !reportLoaded">
  <div class="m-auto">
    <img src="assets/images/no-result.png" alt="">
    <h2 class="text-center">Click on "Run Report" to render the new report</h2>
  </div>
</div>
<ng-template #tabContent >
  <div class="overflow-auto">
    <div class="row mx-0 mt-4" id='allGraphs'>
      <div class="col-lg-6 px-2 mb-3">
        <div class="card h-100">
          <div class="card-body">
            <div *ngIf="selectedReport">
              <button mat-raised-button color="primary" class="on-hover-showbtn" (click)="exportIndividualReport()">EXPORT</button>
              <div id='districtGraph'>
                <app-basic-horizontal-bar-chart [title]="title" [tickMax]="20" [stepSize]="50" [legendData]="['Midyear', 'End Of Year']"
                  [categories]="['DRA','Acumen', 'RIT']" [chartData]="graphData?.data" [extraData]="graphData?.extraData">
                </app-basic-horizontal-bar-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

